import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home/Home";
import TeacherProfile from "./pages/TeacherProfile/TeacherProfile";

function App() {
    return (
        <Router>
            {/*<Navbar />*/}
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/teacher/:id" element={<TeacherProfile />} />
            </Routes>
        </Router>
    );
}

export default App;
